var name = {};
module['exports'] = name;
name.first_name = require("./first_name");
name.last_name = require("./last_name");
name.prefix = require("./prefix");



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/fa/name/index.js
// module id = 1166
// module chunks = 0